import { Skeleton } from 'antd';
import type { FC } from 'react';

const DAY_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const GRID_CELLS = Array.from({ length: 3 * 8 }, (_, idx) => ({
  key: `cell-${idx}`,
  col: idx % 8,
}));

export const CalendarGridSkeleton: FC = () => {
  return (
    <div className="calendar-grid">
      {DAY_LABELS.map((label, i) => (
        <div key={`day-header-${label || 'add'}`} className="calendar-day">
          {i === 0 ? (
            <Skeleton.Button active size="small" style={{ width: 32, height: 32 }} />
          ) : (
            <span style={{ visibility: 'hidden' }}>{label}</span>
          )}
        </div>
      ))}

      {GRID_CELLS.map(({ key, col }) => (
        <div
          key={key}
          className={col === 0 ? 'calendar-day' : 'calendar-cell'}
          style={{ minHeight: 60 }}
        >
          {col === 0 ? (
            <Skeleton.Input active size="small" style={{ width: 70, height: 20 }} />
          ) : (
            <div style={{ width: '100%' }}>
              <Skeleton.Button active size="small" block style={{ height: 24, marginBottom: 4 }} />
              <Skeleton.Input active size="small" style={{ width: '80%', height: 16 }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
